/**
 * Shared frontend classifier for recurring charges.
 * Mirrors the taxonomy in lib/understanding.js (plan 06) so the
 * SubscriptionsScreen and backend agree on kind → class mapping.
 */

/**
 * Classify a merchant/description into a recurring-charge kind.
 * @param {string} name - merchant or transaction description
 * @returns {'housing'|'loan'|'insurance'|'utility'|'subscription'|'travel'|'other'}
 */
export function classifyRecurringKind(name = '') {
  const s = name;
  if (/mortgage|\brent\b|condo|property tax|\bproperty\b|strata|\bhoa\b/i.test(s)) return 'housing';
  if (/loan|line of credit|\bloc\b|financ(e|ing)/i.test(s)) return 'loan';
  if (/insurance|assurance/i.test(s)) return 'insurance';
  if (/hydro|electric|\bgas\b|water|internet|wireless|mobile|\bphone\b|utility|telecom|rogers|bell|telus|fido/i.test(s)) return 'utility';
  // Card annual/membership fees — subscription (cancellable by downgrading/closing).
  if (/\bannual fee\b|\bcard fee\b|membership fee/i.test(s)) return 'subscription';
  if (/air canada|westjet|porter airlines|\bflight\b|airline|expedia|booking\.com|airbnb|hotel|via rail|\buber\b|\blyft\b|\bparking\b|gas station|petro-?canada|\besso\b|\bshell\b/i.test(s)) return 'travel';
  if (/netflix|spotify|disney|crave|youtube|hbo|\bmax\b|paramount|hulu|twitch|gym|fitness|membership|subscription|openai|chatgpt|anthropic|claude|midjourney|patreon|substack|audible|kindle|magazine|adobe|dropbox|notion|icloud|xbox|playstation|nintendo|amazon prime|prime video/i.test(s)) return 'subscription';
  return 'other';
}

/**
 * Map a kind to a coarse class for UI sectioning.
 * @param {string} kind
 * @returns {'subscription'|'essential'|'exclude'}
 */
export function recurringClass(kind) {
  if (kind === 'subscription') return 'subscription';
  if (kind === 'housing' || kind === 'loan' || kind === 'insurance' || kind === 'utility') return 'essential';
  return 'exclude'; // travel, other
}
